/*  assets/infinite-scroll.js – Cats n Scribbles  ✧ 2025-06-22  */
(() => {
  const DEBUG = false;              // flip to true while debugging
  const grid        = document.querySelector('#product-grid');
  const pagination  = document.querySelector('nav.pagination');
  if (!grid || !pagination) return;

  /* ───────────────── sentinel  ───────────────── */
  const sentinel = Object.assign(document.createElement('li'), {
    id: 'cns-scroll-sentinel',
    style: 'width:100%;height:1px',
  });
  grid.append(sentinel);

  /* strict “next” selector – never matches “prev” */
  const nextSel = '[data-pagination-link="next"], a[aria-label="Next page"]';

  /* remember which numeric pages we’ve already appended               */
  const seenPages = new Set([
    +(new URL(location.href).searchParams.get('page') || 1),
  ]);

  let nextURL = pagination.querySelector(nextSel)?.href ?? null;
  log('armed → nextURL =', nextURL);

  const io = new IntersectionObserver(onIntersect, { rootMargin: '400px 0px' });
  io.observe(sentinel);

  /* ─────────────── observer callback ─────────────── */
  async function onIntersect([entry]) {
    if (!entry.isIntersecting || !nextURL) return;

    /* get the page number we’re *about* to request         */
    const pageNo = +(new URL(nextURL).searchParams.get('page') || NaN);
    if (seenPages.has(pageNo)) {
      log('page', pageNo, 'already loaded → disconnect');
      return io.disconnect();                      // duplicate → stop
    }

    document.documentElement.classList.add('loading');

    try {
      const html = await (await fetch(nextURL, { credentials: 'same-origin' })
                          ).text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      /* collect new <li>s – bail if the grid is empty      */
      const items = doc.querySelectorAll('#product-grid > li');
      if (!items.length) {
        log('empty page → disconnect');
        return io.disconnect();
      }

      items.forEach(li => {
        li.classList.add('product-card--fade');
        grid.insertBefore(li, sentinel);
      });

      /* prepare for the *next* round                       */
      const newPag = doc.querySelector('nav.pagination');
      nextURL      = newPag?.querySelector(nextSel)?.href ?? null;
      pagination.innerHTML = newPag?.innerHTML ?? '';

      if (!isNaN(pageNo)) seenPages.add(pageNo);
      history.pushState(null, '', nextURL ?? location.pathname);
      log('loaded page', pageNo, '→ nextURL =', nextURL);

      if (!nextURL) io.disconnect();
    } catch (err) {
      console.error('[CNS-IS] fetch failed →', err);
      io.disconnect();
    } finally {
      document.documentElement.classList.remove('loading');
    }
  }

  /* helper */
  function log(...a) { DEBUG && console.log('[CNS-IS]', ...a); }
})();